import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { MessageService } from 'primeng/api';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { SettingsClassificationTypeResponseModel } from 'src/app/shared/models/response/settings/settings-classificationtype-response-model';
import { ClassificationTypeService } from 'src/app/admin/servicies/classification-type.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import { FacilityService } from 'src/app/admin/servicies/facility.service';
import { WIPStatesResponseModel } from 'src/app/shared/models/response/appointment/wip-states-response-model';
import { InvetoryLocationResponseModel } from 'src/app/shared/models/response/invetory-location-response-model';
import { EMPTY, forkJoin } from 'rxjs';
import { Constants } from 'src/app/shared/constants';

@Component({
    selector: 'app-classification-type-form',
    templateUrl: './classification-type-form.component.html',
    styleUrls: ['./classification-type-form.component.sass'],
    standalone: false
})
export class ClassificationTypeFormComponent extends BaseComponent {
  formGroup: UntypedFormGroup;
  loggedInUserId: number;

  classificationTypeOptions: WIPStatesResponseModel[];
  brightreeStatusOptions: WIPStatesResponseModel[];
  wipAssignedToOptions: WIPStatesResponseModel[];
  InvetoryLocationOptions: InvetoryLocationResponseModel[];
  therapists: { label: string; value: number }[] = [];
  classificationDurationOptions = [
    { label: '15 Minutes', value: 15 },
    { label: '30 Minutes', value: 30 },
    { label: '45 Minutes', value: 45 },
    { label: '60 Minutes', value: 60 },
    { label: '75 Minutes', value: 75 },
    { label: '90 Minutes', value: 90 },
    { label: '105 Minutes', value: 105 },
    { label: '120 Minutes', value: 120 }
  ];

  item: SettingsClassificationTypeResponseModel;
  id = 0;
  showUpdatePODStatus = false;

  constructor(
    webStorageService: WebStorageService,
    private formBuilder: UntypedFormBuilder,
    messageService: MessageService,
    private service: ClassificationTypeService,
    private dynamicDialogRef: DynamicDialogRef,
    dynamicDialogConfig: DynamicDialogConfig,
    private settingsService: AdminSettingsService,
    private facilityService: FacilityService
  ) {
    super(messageService);
    this.item = dynamicDialogConfig.data;
    const loggedInUser = webStorageService.getCurrentUserToken();
    this.loggedInUserId = loggedInUser.userId;
    this.buildForm();
    this.loadData();
    this.loadUpdatePODStatusSetting();
    this.formGroup.get('crmIsEnableAppointmentMaxLimit')?.valueChanges.subscribe(value => {
      const maxAppointmentControl = this.formGroup.get('crmMaxNoOfAppointment');
      if (value) {
        maxAppointmentControl?.setValidators([Validators.required]);
        maxAppointmentControl?.setValue(this.item?.crmMaxNoOfAppointment ?? 0);
        maxAppointmentControl?.markAsDirty();
      } else {
        maxAppointmentControl?.clearValidators();
        maxAppointmentControl?.setValue(0);
      }
      maxAppointmentControl?.updateValueAndValidity();
    });

  }

  private buildForm() {
    this.formGroup = this.formBuilder.group({
      crmClassificationType: ['', Validators.required],
      crmClassificationDisplayName: ['', [Validators.required]],
      crmWIPStatusNameBT: ['', Validators.required],
      crmWIPAssignedToKey: [null],
      crmInvetoryLocationId: [null],
      therapistIds: [null],
      crmIsEnableAppointmentMaxLimit: [false],
      crmMaxNoOfAppointment: [null],
      isUpdatePOD: [false],
      crmClassificaitonduration: [null, Validators.required],
      crmFacilityClassificationDuration: [null, Validators.required],
      crmRemoteClassificationDuration: [null, Validators.required],
      crmRoadHomeClassificationDuration: [null, Validators.required],
      crmDescription: [null, [Validators.required]],
      crmClassificationDocuments: [null],
      blackoutConfig: this.formBuilder.array([])
    });

    const blackoutConfigs = new UntypedFormArray([]);

    blackoutConfigs.push(this.getblackoutConfigForm(0, 1, 'Facility'));
    blackoutConfigs.push(this.getblackoutConfigForm(0, 2, 'Remote'));
    blackoutConfigs.push(this.getblackoutConfigForm(0, 3, 'Road / Home'));

    this.formGroup.setControl('blackoutConfig', blackoutConfigs);
  }

  loadData() {
    this.loading = true;

    if (this.item && this.item.crmClassificationTypeId) {
      this.service.getById(this.item.crmClassificationTypeId).subscribe((res: SettingsClassificationTypeResponseModel) => {
        this.item = res;
        this.setValues(this.item);
      });
    }

    const inventoryLocation$ = this.settingsService.getInvetoryLocation();
    const wipStatusBT$ = this.settingsService.getWipStatusBT();
    const assignedToPerson$ = this.settingsService.getAssignedToPerson();
    const classificationTypeBT$ = this.settingsService.getClassificationTypeBT();
    const therapists$ = this.facilityService.getAllTherapist();

    forkJoin([inventoryLocation$, wipStatusBT$, assignedToPerson$, classificationTypeBT$, therapists$]).subscribe(
      (results) => {
        const [inventoryLocationResult, wipStatusResult, assignedToPersonResult, classificationTypeResult, therapistsResult] = results;

        this.processResult<any>(inventoryLocationResult, () => {
          this.InvetoryLocationOptions = inventoryLocationResult.responseModel;
        });

        this.processResult<any>(wipStatusResult, () => {
          this.brightreeStatusOptions = wipStatusResult.responseModel;
        });

        this.processResult<any>(assignedToPersonResult, () => {
          this.wipAssignedToOptions = assignedToPersonResult.responseModel;
        });

        this.processResult<any>(classificationTypeResult, () => {
          this.classificationTypeOptions = classificationTypeResult.responseModel;
        });

        this.therapists =  therapistsResult.responseModel.map(t=>{
          return {
            label: t.appUserLname + ', ' + t.appUserFname,
            value: t.appUserInfoId
          };
        });

        this.loading = false;
      },
      (error) => {
        console.error('Error loading data', error);
        this.loading = false;
      }
    );
  }

  private loadUpdatePODStatusSetting() {
    this.settingsService.getSettingsByKey(Constants.SettingKeys.UpdatePODStatusClassificationTypeWise).subscribe((res: any) => {
      this.showUpdatePODStatus = res?.responseModel?.schSettingValue?.toLowerCase() === 'true';
    });
  }

  private setValues(item: SettingsClassificationTypeResponseModel) {
    this.id = item.crmClassificationTypeId;
    this.formGroup.patchValue({
      crmClassificationType: item.crmClassificationType,
      crmClassificationDisplayName: item.crmClassificationDisplayName,
      crmWIPStatusNameBT: item.crmWIPStatusNameBT,
      crmWIPAssignedToKey: item.crmWIPAssignedToKey,
      crmInvetoryLocationId: item.crmInvetoryLocationId,
      therapistIds: item.therapistIds,
      crmIsEnableAppointmentMaxLimit: item.crmIsEnableAppointmentMaxLimit,
      crmMaxNoOfAppointment: item.crmMaxNoOfAppointment ? item.crmMaxNoOfAppointment : 0,
      isUpdatePOD: item.isUpdatePOD,
      crmClassificaitonduration: item.crmClassificaitonduration,
      crmFacilityClassificationDuration: item.crmFacilityClassificationDuration,
      crmRemoteClassificationDuration: item.crmRemoteClassificationDuration,
      crmRoadHomeClassificationDuration: item.crmRoadHomeClassificationDuration,
      crmDescription: item.crmDescription,
      crmClassificationDocuments: item.crmClassificationDocuments
    });

    const blackoutConfigs = new UntypedFormArray([]);
    item.blackoutConfig.forEach((c) => {
      blackoutConfigs.push(this.getblackoutConfigForm(c.id, c.visitTypeId, c.visitTypeName, c.blackoutDays, c.applicableForId, c.includeWeekend));
    });

    this.formGroup.setControl('blackoutConfig', blackoutConfigs);
  }

  save() {
    const isValid = this.validForm(this.formGroup, true);
    if (!isValid || this.formGroup.invalid) {
      return;
    }


    const request = Object.assign(this.item ? this.item : {}, this.formGroup.getRawValue()) as SettingsClassificationTypeResponseModel;
    request.modifiedByUserInfoId = this.loggedInUserId;
    this.loading = true;
    this.service.save(request).subscribe(() => {
      this.loading = false;
      this.showSuccessMessage(`Classification type information has been ${this.id ? 'updated' : 'added'} successfully.`);
      this.close(true);
    }, () => {
      this.loading = false;
    });
  }

  close(result: any) {
    setTimeout(() => {
      this.dynamicDialogRef.close(result);
    }, 1);
  }

  onAllowedmaxAppointment() {
    this.formGroup.updateValueAndValidity();
  }

  getblackoutConfigForm(id: number, visitTypeId: number, visitTypeName: string, blackoutDays: number = 0, applicableForId: number = 1, includeWeekend: boolean = false) {
    return this.formBuilder.group({
      id: id,
      visitTypeId: visitTypeId,
      visitTypeName: visitTypeName,
      blackoutDays: [
        blackoutDays,
        [Validators.required, Validators.max(999), Validators.pattern(/^\d+$/)]
      ],
      applicableForId: applicableForId,
      includeWeekend: includeWeekend
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  get blackoutConfigs() {
    return this.formGroup.controls['blackoutConfig'] as UntypedFormArray;
  }
}
